import { COMMERCIAL_TAB_TITLE } from "@/pages/Explorer/constants/explorer.constants";

export const localBreadCrumbDispatch = {
  CommercialExplorer: {
    path: "/explorer/commercial",
    label: COMMERCIAL_TAB_TITLE,
    name: "CommercialExplorer",
  },
  TradeHub: {
    path: "/trading/trade-hub",
    label: "Trade Hub",
    name: "TradeHub",
  },
  TechnicalInsights: {
    path: "/explorer/technical-insights",
    label: "Technical Insights",
    name: "TechnicalInsights",
  },
  Benchmarking: {
    path: "/explorer/benchmarking",
    label: "Benchmarking",
    name: "Benchmarking",
  },
  SchedulingHub: {
    path: "/scheduling",
    label: "Scheduling",
    name: "SchedulingHub",
  },
};

export const dispatchedFromComponent = {
  [localBreadCrumbDispatch.CommercialExplorer.name]:
    localBreadCrumbDispatch.CommercialExplorer.path,
  [localBreadCrumbDispatch.TradeHub.name]:
    localBreadCrumbDispatch.TradeHub.path,
  [localBreadCrumbDispatch.TechnicalInsights.name]:
    localBreadCrumbDispatch.TechnicalInsights.path,
  [localBreadCrumbDispatch.Benchmarking.name]:
    localBreadCrumbDispatch.Benchmarking.path,
  [localBreadCrumbDispatch.SchedulingHub.name]:
    localBreadCrumbDispatch.SchedulingHub.path,
};

/**
 * Adds spaces before capital letters in a component name
 * e.g., "CommercialExplorer" -> "Commercial Explorer"
 */
export const formatComponentName = (name: string): string => {
  return name.replace(/([A-Z])/g, " $1").trim();
};

export const shouldHandleOwnBreadcrumbs = (path: string) => {
  return Object.values(dispatchedFromComponent).some((dispatchedPath) =>
    path.startsWith(dispatchedPath)
  );
};
